module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAMAAACDi47UAAAAflBMVEVHcEyYlJSYlJSYlJSYlJSYlJSYlJSYlJSYlJSYlJSYlJSYlJSYlJSYlJSYlJSYlJSYlJSYlJSYlJSYlJSYlJSYlJSYlJSYlJSYlJSYlJSYlJSYlJSYlJSYlJSYlJSYlJSYlJSYlJSYlJSYlJSYlJSYlJSYlJSYlJSYlJSYlJS/0eVRAAAAKXRSTlMAVH5WIHxQ4yjBkE1pc+hsgI9Cxxfq9fETmLA8wKMC7ZXIqveU+zmvmkVJb/8AAABcSURBVAgdBcGFAcJAAASwAIV+seLufvsvSKKdjgGAT/0ySToAUN75MUsGAJRnvtBPegBlmwfQTUZAtckBYJgsYLVOA8A8ObKr0wDAPqkudZYAwC255gQAcE7uAH8RpgeKJFS/AwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/styles/common/img/unfold.png
// module id = n+sb
// module chunks = 37